module.exports = {
          srcSet: __webpack_public_path__ + "2688e661167c33c0f51a387960aa4291-90.png"+" 90w",
          images:[ {path: __webpack_public_path__ + "2688e661167c33c0f51a387960aa4291-90.png",width: 90,height: 90}],
          src: __webpack_public_path__ + "2688e661167c33c0f51a387960aa4291-90.png",
          toString:function(){return __webpack_public_path__ + "2688e661167c33c0f51a387960aa4291-90.png"},
          
          width: 90,
          height: 90
        }